/** biome-ignore-all lint/correctness/noProcessGlobal: using it here seems reasonable, as it has to run both in browser and node, importing the node pkg here would needlessly complicate the code */
export default function isElectron() {
  // console.error(window.process, navigator.userAgent);
  // return false;

  // Renderer process
  if (
    typeof window !== "undefined" &&
    typeof window.process === "object" &&
    (window.process as { type: "renderer" }).type === "renderer"
  ) {
    return true;
  }

  // Main process
  if (typeof process !== "undefined" && typeof process.versions === "object" && process.versions.electron) {
    return true;
  }

  // Detect the user agent when the `nodeIntegration` option is set to false.
  // Also require `window.require` so we don't false-positive inside other Electron
  // shells (Claude Code desktop, Cursor, …) that host us as a sandboxed web page —
  // there the UA contains "Electron" but the electron APIs we depend on are absent,
  // and calling window.require(...) would throw and blank the app.
  if (
    typeof navigator === "object" &&
    typeof navigator.userAgent === "string" &&
    navigator.userAgent.indexOf("Electron") >= 0 &&
    typeof (window as { require?: unknown }).require === "function"
  ) {
    return true;
  }

  return false;
}
